import React, { useState, useEffect } from "react";
import { formatDuration } from "../../../utils";

export const TimelineRuler: React.FC<{ zoom: number, duration: number }> = ({ zoom, duration }) => {
  const [markers, setMarkers] = useState<{ time: number, label: string }[]>([]);

  useEffect(() => {
    const newMarkers = [];
    const minSpacingPx = 70;
    const minSpacingSec = minSpacingPx / zoom;
    const possibleSteps = [0.1, 0.2, 0.5, 1, 2, 5, 10, 15, 30, 60, 120, 300, 600];
    const step = possibleSteps.find(s => s > minSpacingSec) || 600;
    for (let s = 0; s <= duration; s += step) {
      newMarkers.push({ time: s, label: formatDuration(s) });
    }
    setMarkers(newMarkers);
  }, [zoom, duration]);

  return (
    <div className="h-8 relative select-none text-xs text-gray-400 mb-2 border-b border-gray-800">
      {markers.map(({ time, label }) => (
        <div key={time} className="absolute -top-3 h-full" style={{ left: `${time * zoom}px` }}>
          <div className="w-px h-2 bg-gray-500" />
          <span className="absolute left-1 top-2">{label}</span>
        </div>
      ))}
    </div>
  );
};
